import internalServerErrorImg from '@assets/status-pages/internal_server_error.webp';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { translateItem } from '@utils/translations.ts';

import { Header, NoDataServerErrorWrapper, SubHeader, Text } from './styled.tsx';

export const SHARED_EMPTY_STATE_SERVER_ERROR = msg`Internal Server Error!`;
export const SHARED_EMPTY_STATE_SERVER_ERROR_INFO = msg`Something went wrong. We’re working to fix it.`;

const NoDataServerError = () => {
    const { t } = useLingui();

    return (
        <NoDataServerErrorWrapper>
            <img src={internalServerErrorImg} alt={t`server error`} />
            <Header>500</Header>
            <SubHeader>{translateItem(SHARED_EMPTY_STATE_SERVER_ERROR)}</SubHeader>
            <Text>{translateItem(SHARED_EMPTY_STATE_SERVER_ERROR_INFO)}</Text>
        </NoDataServerErrorWrapper>
    );
};

export default NoDataServerError;
